/* istanbul ignore file */
import React, { useCallback, memo } from "react";
import IconButton from "@mui/material/IconButton";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import Tooltip from "@mui/material/Tooltip";
import { useDispatch } from "react-redux";
import { setGlobalLoader } from "../../store/globalSlice";
import { persistor } from "../../store";
import oktaAuth from "../../okta";

const LogoutButton = () => {
  const dispatch = useDispatch();

  const handleLogout = useCallback(() => {
    window.localStorage.removeItem("feature");
    dispatch(setGlobalLoader(true));
    oktaAuth.signOut();
    // Threshold for resetting state values.
    setTimeout(() => {
      persistor.purge();
    }, 30);
  }, [dispatch]);

  return (
    <Tooltip title="Logout" arrow>
      <IconButton aria-label="logout" color="inherit" onClick={handleLogout}>
        <PowerSettingsNewIcon />
      </IconButton>
    </Tooltip>
  );
};

export default memo(LogoutButton);
